import React, { useEffect } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import classnames from 'classnames/bind';

import { notify } from '@NOTIFICATION/Notificator';

import { useCreateUsers } from '@SERVICES';

import useInviteUserModal from '@HOOKS/store/modals/useInviteUserModal';

import BaseModal from '@MODALS/BaseModal';

import UserInvitationForm from '@COMPONENTS/SHARED/UserInvitationForm';

import styles from './InviteUserModal.module.scss';

const cx: CX = classnames.bind(styles);

function InviteUserModal() {
    const {
        actions: inviteUserModalActions,
    } = useInviteUserModal(() => true);

    const [
        createUsers,
        {
            isLoading, isSuccess, isError, error,
        },
    ] = useCreateUsers();

    useEffect(() => {
        if (isSuccess) {
            notify.info('User invitation(s) sent successfully!', {
                toastId: 'invite-user-success',
            });

            inviteUserModalActions.close();
        }
    }, [isSuccess, inviteUserModalActions]);

    useEffect(() => {
        if (isError) {
            if ((error as FetchBaseQueryError).status === 403) {
                notify.error('Permission denied', {
                    toastId: 'invite-user-permission-error',
                });
            } else if ((error as FetchBaseQueryError).status === 400) {
                const errorData = (error as any)?.data;
                if (errorData?.message) {
                    notify.error(errorData.message, {
                        toastId: 'invite-user-error',
                    });
                } else {
                    notify.error('Some users already exist or invalid data provided', {
                        toastId: 'invite-user-error',
                    });
                }
            } else {
                notify.error('Something went wrong!', {
                    toastId: 'invite-user-error',
                });
            }
        }
    }, [isError, error]);

    function handleClose() {
        inviteUserModalActions.close();
    }

    const onSave = (createUsersParams: any) => {
        createUsers(createUsersParams);
    };

    return (
        <BaseModal
            style={{ maxWidth: 800, width: '90%' }}
            onClose={() => handleClose()}
        >
            <div className={cx('invite-user-modal')}>
                <div className={cx('title')}>
                    Invite New User
                </div>
                <div className={cx('description')}>
                    Fill in the user details below. An invitation email will be sent to the user with login instructions.
                </div>
                <div className={cx('form-wrapper')}>
                    <UserInvitationForm
                        buttonTitle="Send Invitation"
                        isLoading={isLoading}
                        defaultValues={{
                            email: '',
                            firstName: '',
                            lastName: '',
                            fullName: '',
                            userType: 'Full-Time Employee',
                            mobilePhone: '',
                            officePhone: '',
                            country: '',
                            title: '',
                        }}
                        onSave={onSave}
                    />
                </div>
            </div>
        </BaseModal>
    );
}

export default InviteUserModal; 